"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const svgIcons_1 = require("../../../../svgIcons");
require("./plans.scss");
const SubscriptionPlanInfo = (props) => {
    const { list, title, description, currency = 'US ', priceDetails, status, isSubscribed, onSubscribeAction, onUnsubscribeAction, onFreePlanAction, renewDate, isPaid, trialUsed } = props, others = __rest(props, ["list", "title", "description", "currency", "priceDetails", "status", "isSubscribed", "onSubscribeAction", "onUnsubscribeAction", "onFreePlanAction", "renewDate", "isPaid", "trialUsed"]);
    return (react_1.default.createElement("div", { className: `plan-box ${isPaid ? 'paid' : ''}` },
        react_1.default.createElement("div", { className: 'plan-info' },
            react_1.default.createElement("h3", null, title),
            react_1.default.createElement("p", { className: "sub-title pl-20 pr-20" }, description),
            priceDetails && react_1.default.createElement("p", { className: "price-title" },
                react_1.default.createElement("span", { className: "currency" }, currency),
                priceDetails),
            status && react_1.default.createElement("p", { className: "status" }, status),
            (onSubscribeAction && onUnsubscribeAction) && react_1.default.createElement("p", { className: `mr-b-30 ${isSubscribed ? 'unsubscribe-gradient-border' : ''}` },
                react_1.default.createElement("button", { onClick: () => {
                        if (isSubscribed) {
                            return onUnsubscribeAction(); // unsubscribe-gradient-border
                        }
                        return onSubscribeAction();
                    }, className: isSubscribed ? 'unsubscribe-btn' : 'subscribe-btn' }, isSubscribed ? 'Unsubscribe' : 'Subscribe'))),
        react_1.default.createElement("div", { className: "plan-list" }, list.map((item, key) => react_1.default.createElement("div", { key: key, className: 'plan-list-item' },
            item.active ? react_1.default.createElement(svgIcons_1.GreenCheckIcon, null) : react_1.default.createElement(svgIcons_1.GrayCloseIcon, null),
            item.title))),
        (onFreePlanAction && (!isSubscribed && !renewDate && !trialUsed)) && react_1.default.createElement("span", { className: "link" },
            react_1.default.createElement("a", { onClick: () => onFreePlanAction() }, "Try It For Free for 14 Days")),
        (renewDate && !isSubscribed) && react_1.default.createElement("div", { className: 'active-period' },
            react_1.default.createElement(svgIcons_1.InfoIcon, null),
            react_1.default.createElement("span", null,
                "You have paid for Early Bird plan and can use the benefits until ",
                renewDate,
                "."))));
};
exports.default = SubscriptionPlanInfo;
